<template>
  <div class="header">
    <div class="header-imgwrapper">
      <Lottie :options="lottieOptionsHand" />
    </div>
    <div class="header-rule" @click="handleRule" ></div>
    <div class="share" @click="handleShare" v-if="!isApp && !isWeixin"></div>
    <SharePoster
      ref="poster"
      :type="2"
    />
  </div>
</template>

<script>
// import { isApp } from '@/common/utils/xesFunction.js'
import { isApp, isWeixin } from '@/common/utils'
import Lottie from './lottie'
import animationData from '../assets/lottie/111.json'
import SharePoster from '@/summerCamp/components/sharePoster'

export default {
  name: 'righting',
  props: {
    ruleShow: {
      type: Boolean
    }
  },
  data() {
    return {
      width: 100,
      height: 100,
      isApp,
      isWeixin,
      style: {
        width: '200px',
        height: '200px',
        overflow: 'hidden',
        margin: '0 auto'
      },
      lottieOptionsHand: {
        loop: true,
        autoplay: true,
        animationData: animationData
      } // 动画配置
    }
  },
  created() {
    console.log('isapp', this.isApp)
  },
  components: {
    Lottie,
    SharePoster
  },
  methods: {
    handleRule() {
      // 规则
      this.$xesLogger.clickMsg({
        params: {
          clickid: 21,
          action: 'click',
          elemname: '点击查看活动规则'
        }
      })
      this.$emit('changeRuleState', true)
    },
    handleShare() {
      this.$xesLogger.clickMsg({
        params: {
          clickid: 16,
          action: 'click',
          elemname: '分享主会场'
        }
      })
      this.$refs.poster.show()
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  position: relative;
  // background: #f7cb45;

  .share {
    position: fixed;
    top: 30px;
    right: 0;
    z-index: 120;
    width: 75px/2;
    height: 44px/2;
    background: url(../assets/images/share-h5.png) no-repeat;
    background-size: 100% auto;
    // background-size: 100% auto;
  }

  .header-imgwrapper {
    background: url('https://editor.xesimg.com/tailor/resource/BG-1622776456748.png');
    background-size: 100% 100%;
  }

  &-share {
    position: absolute;
    top: 10px;
    right: 0;
  }

  &-rule {
    position: fixed;
    top: 90px;
    right: 0;
    z-index: 2;
    width: 45px/2;
    height: 147px/2;
    background: url('../assets/images/rule-btn.png') no-repeat;
    background-size: cover;
  }

  &-imgwrapper {
    width: 100%;
    // 图片高/图片宽
    // padding-bottom: 302/300*100%;

    // &-img {
    //   position: absolute;
    //   top: 0;
    //   left: 0;
    //   width: 100%;
    //   height: 100%;
    // }
  }
}
</style>
